import {AccountIcon} from '../icon/svg/account-icon';
import {ContactIcon} from '../icon/svg/contact-icon';
import {LeadIcon} from '../icon/svg/lead-icon';

import type {CustomFieldEntityOption, CustomFieldTypeOption} from './types';

/**
 * List of options for entity type select
 * @type {[{label: string, value: string}, {label: string, value: string}, {label: string, value: string}]}
 */
export const ENTITY_TYPE_SELECT_OPTIONS: Array<CustomFieldEntityOption> = [
    {value: 'Accounts', label: 'Company', icon: AccountIcon},
    {value: 'Contacts', label: 'Person', icon: ContactIcon},
    {value: 'Leads', label: 'Lead', icon: LeadIcon},
];

/**
 * List of custom field options for all entities (Leads, Contacts, Accounts) - see function getAvailableTypesForEntityName
 * @type {{label: string, value: string, sublabel: string}[]}
 */
export const ALL_ENTITY_CUSTOM_FIELD_SELECT_OPTIONS: Array<CustomFieldTypeOption> = [
    {
        value: 'STRING',
        label: 'Text',
        sublabel: 'Quick info like invoice numbers of SKUs',
    },
    {
        value: 'TEXT',
        label: 'Long text',
        sublabel: 'Notes and paragraphs of information',
    },
    {
        value: 'CURRENCY',
        label: 'Currency',
        sublabel: 'Monetary values',
    },
    {
        value: 'DATE',
        label: 'Date',
        sublabel: 'Day, month, and year',
    },
    {
        value: 'ENUM',
        label: 'Decision',
        sublabel: 'Select single or multiple values from a list',
    },
];

/**
 * List of custom field options only available for lead entities - see function getAvailableTypesForEntityName
 * @type {{label: string, value: string, sublabel: string}[]}
 */
export const LEAD_CUSTOM_FIELD_SELECT_OPTIONS: Array<CustomFieldTypeOption> = [
    {
        value: 'EMAIL',
        label: 'Email',
        sublabel: 'Email address value',
    },
    {
        value: 'LOCATION',
        label: 'Address',
        sublabel: "Postal address that aren't specific to a company/person",
    },
    {
        label: 'Phone',
        value: 'PHONE',
        sublabel: 'Dialable telephone number',
    },
    {
        value: 'URL',
        label: 'URL',
        sublabel: 'Website address',
    },
];
